
import Carousel from '@/ui-kit/components/carousel';
import { CarouselSlotName, CarouselPropsEventType } from '@/ui-kit/components/carousel/enums';
import CarouselItem from '@/ui-kit/components/carousel-item';
import IconButton from '@/ui-kit/components/icon-button';
import { StyleFillType } from '@/ui-kit/components/icon-button/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';
import ListingBookViewingDateCard from './date-card';
import { BOOK_VIEWING_CAROUSEL_BREAKPOINTS } from '../owner-contacts/constants';
import { BookViewingCarouselPropsEventType } from '../owner-contacts/enums';

export default {
  name: 'ListingOwnerContactsBookViewingDateCarousel',
  components: {
    Carousel,
    CarouselItem,
    IconButton,
    ListingBookViewingDateCard,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    activeIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      CarouselSlotName,
      CarouselPropsEventType,
      IconType,
      StyleColorSchemeType,
      StyleFillType,
      StyleSizeType,
      BOOK_VIEWING_CAROUSEL_BREAKPOINTS,
    };
  },
  methods: {
    getIsActive(index) {
      return index === this.activeIndex;
    },
    handleCardClick(index) {
      this.$emit(BookViewingCarouselPropsEventType.SelectItem, index);
    },
    handleActiveIndexChange(index) {
      this.$emit(BookViewingCarouselPropsEventType.ActiveIndexChange, index);
    },
    handleBreakpointChange({ slidesPerView }) {
      this.$emit(BookViewingCarouselPropsEventType.ItemsAmountChange, slidesPerView);
    },
  },
};
